import React, { useEffect, useState } from 'react';

import { ListPropsHelper } from '../list-props-helper/list-props-helper';
import ShowIf from '../show-if/show-if';
import './mutable-accordion.scss';

export type MutableAccordionItemProps = {
  isExpanded: boolean;
};

export type MutableAccordionItem = {
  title: string;
  render: () => React.ReactFragment;
  remove: () => void;
  automationIdDescription: string;
  disabled?: boolean;
};

export type MutableAccordionProps = {
  items: MutableAccordionItem[];
  automationIdPrefix: string;
};

export function MutableAccordion({ automationIdPrefix, items }: MutableAccordionProps) {
  const [props, setProps] = useState<MutableAccordionItemProps[]>([{ isExpanded: true }]);

  const getAutomationId = (automationIdSuffix) => `${automationIdPrefix}_${automationIdSuffix}`;

  useEffect(() => {
    const propsNewCount = items.length - props.length;

    if (propsNewCount > 0) {
      const propsNew: MutableAccordionItemProps[] = [
        ...props.map((propsItem) => ({ ...propsItem, isExpanded: false })),
      ];
      for (let i = 0; i < propsNewCount; i++) {
        propsNew.push({ isExpanded: true });
      }
      setProps(propsNew);
    }
  }, [items]);

  return (
    <div className="MutableAccordion" automationid={getAutomationId('Mutable_Accordion_Main')}>
      <ListPropsHelper<MutableAccordionItemProps> listProps={props} setListProps={setProps}>
        {({ index, props: itemProps, setProps: setItemProps }) => {
          const listItem = items[index];
          const disabled = items[index].disabled;

          if (!listItem) {
            return <div key={index} />;
          }

          return (
            <div
              className={`item ${disabled ? 'disabled' : ''}`}
              key={index}
              automationid={getAutomationId(
                `Mutable_Accordion_Child_${index}_${listItem.automationIdDescription}`,
              )}
            >
              <div
                automationid={getAutomationId(
                  `Mutable_Accordion_Child_${index}_${listItem.automationIdDescription}_Div_Button_Show_Content`,
                )}
                className={`accordion-heading  ${itemProps.isExpanded ? 'expanded' : ''}`}
              >
                <div className="accordion-heading-text">{listItem.title}</div>

                <ShowIf condition={!disabled}>
                  <div
                    className={`chevron-button ${itemProps.isExpanded ? 'expanded' : ''}`}
                    onClick={() => {
                      setItemProps((propsCurrent) => ({
                        ...propsCurrent,
                        isExpanded: !propsCurrent.isExpanded,
                      }));
                    }}
                  />
                </ShowIf>

                <ShowIf condition={items.length > 1}>
                  <div
                    className="delete-button"
                    onClick={() => {
                      listItem.remove();
                      const listPropsNew = [...props];
                      listPropsNew.splice(index, 1);
                      setProps(listPropsNew);
                    }}
                  />
                </ShowIf>
              </div>

              <ShowIf condition={itemProps.isExpanded}>
                <div>{listItem.render()}</div>
              </ShowIf>
            </div>
          );
        }}
      </ListPropsHelper>
    </div>
  );
}
